import { useSelector } from 'react-redux'

import {
  ZOOM_BANNER_HEIGHT,
  ZOOM_INFORMED_CONSENT_BANNER_HEIGHT,
  ZOOM_RECORDING_CONSENT_BANNER_HEIGHT,
} from '@lyrahealth-inc/ui-core-crossplatform/src/organisms/zoomVideoSession/constants'

import { useVideoSessionBanners } from '../lyraTherapy/consent/data/hooks/useVideoSessionBanners'
import { getInformedConsentBannerHeight, getLTVideoSessionAppointment } from '../lyraTherapy/data/ltVideoSelectors'
import { useVideoSessionForAppointment } from '../lyraTherapy/data/useVideoSessionForAppointment'

/**
 * Height of everything rendered above the page content while a video session is open: the Zoom
 * banner plus whichever consent banner is showing. Banner visibility comes from the same hook, and
 * the same stored appointment, that ProviderSession renders from, so this can't drift from what's
 * actually on screen.
 */
export const useVideoSessionBannerHeight = () => {
  const appointment = useSelector(getLTVideoSessionAppointment)
  const videoSession = useVideoSessionForAppointment(appointment?.appointmentId)
  const { showRecordingConsentBanner, informedConsentBanner } = useVideoSessionBanners({ videoSession, appointment })
  // Measured from the rendered banner (its text can wrap); the constant is the fallback for the
  // first frame before onLayout fires
  const measuredInformedConsentBannerHeight = useSelector(getInformedConsentBannerHeight)

  if (!appointment) {
    return 0
  }

  if (showRecordingConsentBanner) {
    return ZOOM_BANNER_HEIGHT + ZOOM_RECORDING_CONSENT_BANNER_HEIGHT
  }

  if (informedConsentBanner) {
    return ZOOM_BANNER_HEIGHT + (measuredInformedConsentBannerHeight || ZOOM_INFORMED_CONSENT_BANNER_HEIGHT)
  }

  return ZOOM_BANNER_HEIGHT
}
